import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion, Popup, Icon, Grid, Menu } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import './Sidebar.scss';
import styles from './../../styles/global.module.scss';
import { connect } from 'react-redux';
import passengerActions from '../../store/actions/passengers';

function getWindowDimensions() {
	const { innerWidth: width, innerHeight: height } = window;
	return {
		width,
		height,
	};
}

const PassengerSidebarMenu = (props) => {
	const { t } = useTranslation();
	const { expand, setExpand, location, mobileOnly, setMobileOnly, lang, onTabOpen } = props;

	const [windowDimensions, setWindowDimensions] = useState(
		getWindowDimensions()
	);
	const [isActive, setIsActive] = useState(false);
	const [availableRoutes, setAvailableRoutes] = useState([]);
	const [allowedRoutes, setAllowedRoutes] = useState([]);

	useEffect(() => {
		componentDidMount();
	}, []);

	useEffect(() => {
		function handleResize() {
			if (windowDimensions !== getWindowDimensions()) {
				setWindowDimensions(getWindowDimensions());
			}
		}

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [windowDimensions]);

	useEffect(() => {
		if (windowDimensions.width <= 425) {
			setMobileOnly(true);
			if (expand === 1 || expand == null) setExpand(1);
		} else {
			setMobileOnly(false);
		}
	}, [windowDimensions]);
	useEffect(() => {
		if (!location) return;
		if (mobileOnly) setExpand(1);
	}, [location, mobileOnly]);

	/**
	 * Carga inicial de módulos y permisos
	 */
	const componentDidMount = async () => {
		const [availableRoutes, allowedRoutes] = await Promise.all([
			props.getPassengerModules(),
			props.getWebPassengerPermissions(props.passenger.id),
		]);

		setAvailableRoutes(availableRoutes);
		setAllowedRoutes(allowedRoutes);
	};

	const handleTabOpen = (e, route) => {
		if (typeof onTabOpen === 'function') {
			e.preventDefault();
			onTabOpen(route);
		}
	};

	return (
		<div
			className="sidebar"
			style={expand == null || expand == 1 ? { width: '250px' } : null}
		>
			<Accordion
				key={`accordion-menu-sidebar`}
				fluid
				style={{ paddingLeft: '12px', paddingBottom: '5px' }}
			>
				{/* Filtrar módulos con al menos una ruta permitida */}
				{availableRoutes
					.filter((module) => {
						const moduleName = Object.keys(module)[0];
						const submodules = module[moduleName].routes;
						return submodules.some((route) => allowedRoutes.includes(route.url));
					})
					.map((module) => {
						const moduleName = Object.keys(module)[0];
						const data = module[moduleName] || {};
						const submodules = data.routes || [];

						return (
							<Accordion.Title
								key={`title-${moduleName}`}
								active={isActive}
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									setIsActive(!isActive);
								}}
							>
								<Popup
									trigger={
										<Menu.Item
											className={`${styles.shrinkOnHover} SubMenu__Item`}
											style={{ width: '100%', display: 'inline-block' }}
										>
											<Icon
												name={data.icon}
												size="large"
												className="SideBar__Outline"
											/>
											{(expand == null || expand == 1) && (
												<h5 className="menu-row-title">
													{t(moduleName)}
												</h5>
											)}
										</Menu.Item>
									}
									positionFixed
									position="right center"
									pinned
									hoverable
									closeOnTriggerClick={true}
									offset={[0, 0]}
									className="SubMenu__Content"
									content={
										<Grid divided="vertically" style={{ width: '15rem' }}>
											<Grid.Row style={{ paddingBottom: 0 }}>
												<Grid.Column>
													<h4>
														{t(moduleName)}
													</h4>
												</Grid.Column>
											</Grid.Row>
											<Grid.Row style={{ paddingTop: '0', paddingBottom: '0' }}>
												<Grid.Column>
													<Accordion.Content
														key={`content-${moduleName}`}
														style={{
															marginTop: '0px',
															paddingTop: '0px',
														}}
														active={isActive}
													>
														<Menu
															vertical
															fluid
															text
															style={{ paddingLeft: '30px' }}
														>
															{/* Mostrar solo rutas permitidas */}
															{submodules
																.filter((route) =>
																	allowedRoutes.includes(route.url)
																)
																.map((route) => (
																	<Link
																		key={`link-${route.url}`}
																		to={route.url}
																		className="sub_menu_row"
																		onClick={(e) => handleTabOpen(e, route)}
																	>
																		<Menu.Item
																			className={styles.growOnHover}
																			style={{ margin: '0' }}
																		>
																			{t(route.name)}
																		</Menu.Item>
																	</Link>
																))}
														</Menu>
													</Accordion.Content>
												</Grid.Column>
											</Grid.Row>
										</Grid>
									}
								/>
							</Accordion.Title>
						);
					})}
			</Accordion>
		</div>
	);
};

const mapStateToProps = (state) => ({
	passenger: state.app.passenger,
	lang: state.app.lang,
});

const mapDispatchToProps = (dispatch) => ({
	getPassengerModules: () => dispatch(passengerActions.getPassengerModules()),
	getWebPassengerPermissions: (passengerId) =>
		dispatch(passengerActions.getWebPassengerPermissions(passengerId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PassengerSidebarMenu);
